import { Checkbox, FormControlLabel, Grid } from '@mui/material';
import { Fragment, memo } from 'react';
import { useHttpFetch } from 'shell/hooks/use-http-fetch';
import { __CERTIFICATION_API_URL__ } from 'shell/constants/environment';
import { HttpResponseList } from 'shell/models/http-response';
import { CertificateTypeANPRList } from 'shell/models/certificate-type';
import { Operation } from 'shell/view-models/operation';
import { DocumentType } from 'front-office/constants/document-type';

interface AuthenticCheckboxesProps {
  values?: CertificateTypeANPRList;
  onChange: (identifier: CertificateTypeANPRList) => void;
}

const StatementsCheckboxesComponent = ({
  values,
  onChange,
}: AuthenticCheckboxesProps): React.ReactElement => {
  const [typeCertificateCheckbox] = useHttpFetch<
    HttpResponseList<CertificateTypeANPRList>,
    Array<CertificateTypeANPRList>
  >(`${__CERTIFICATION_API_URL__}/certificazione/tipi-documento`, {
    onBootstrap: true,
    initialData: [],
    options: {
      params: {},
      paramsSerializer: () =>
        `filters=tipoDocumento:${DocumentType.Dichiarazione}:${Operation.EQUALS}&filters=flagDocumentoInUso:1:${Operation.EQUALS}`,
    },
    transformer: (response) => {
      return response.data.payload?.list?.filter(
        (element) => element.key.codiceDocumento !== 'CO'
      ) as Array<CertificateTypeANPRList>;
    },
  });

  const checkboxList = (typeCertificateCheckbox.data as Array<CertificateTypeANPRList>) || [];

  return (
    <Fragment>
      {checkboxList.map((element) => {
        const isSelected = values?.key.codiceDocumento === element.key.codiceDocumento;

        return (
          <Grid item xs={12} md={4} key={element.key.codiceDocumento}>
            <FormControlLabel
              control={
                <Checkbox
                  id={element.key.codiceDocumento}
                  checked={isSelected || false}
                  onChange={() => onChange(element)}
                  inputProps={{ 'aria-label': element.descrizioneTipoDocumento }}
                />
              }
              label={element.descrizioneTipoDocumento}
            />
          </Grid>
        );
      })}
    </Fragment>
  );
};

StatementsCheckboxesComponent.displayName = 'Statements checkboxes component';

const StatementsCheckboxes = memo(StatementsCheckboxesComponent);

export default StatementsCheckboxes;
